class InputSelect {
  constructor(selector) {
    [...document.querySelectorAll(selector)].forEach((el) => {
      el.addEventListener('focus', (e) => {e.currentTarget.setSelectionRange(0, el.value.length);})
    });
  }
}

export default InputSelect;
